import React from 'react';
import { Reveal } from './ui/Reveal';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-84">
      <div className="absolute top-0 left-0 w-full h-full bg-brand-sand/50 -z-10" data-id="element-85" />

      <div className="max-w-6xl mx-auto px-6" data-id="element-86">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-87">
          <div className="max-w-2xl" data-id="element-88">
            <Reveal data-id="element-89">
              <span className="inline-block py-1 px-3 rounded-full bg-brand-sage/20 text-brand-forest font-medium text-sm mb-6 tracking-wide uppercase" data-id="element-90">
                Método Natural Comprobado
              </span>
            </Reveal>

            <Reveal delay={0.1} data-id="element-91">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-92">
                ¿Harta de dietas que te hacen sufrir?
              </h1>
            </Reveal>

            <Reveal delay={0.2} data-id="element-93">
              <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-94">
                Descubre el método natural en 24 pasos para alcanzar tu peso
                ideal, sin pasar hambre, sin efecto rebote y transformando tus
                hábitos desde la raíz.
              </p>
            </Reveal>

            <Reveal delay={0.3} data-id="element-95">
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-96">
                <Button href="#final-cta" className="group" data-id="element-97">
                  Quiero empezar hoy
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-98" />
                </Button>
              </div>
              <p className="mt-4 text-sm text-gray-500 flex items-center gap-2" data-id="element-99">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-100" />
                Garantía total de 7 días
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.4} className="relative" data-id="element-101">
            <div className="absolute inset-0 bg-brand-sage/20 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-102" />
            <img src="https://cdn.magicpatterns.com/uploads/vdc5d7EumXkX8FVjuUYyEa/24-PasosATuPesoIdeal_400x210.jpg" alt="24 Pasos a Tu Peso Ideal - Mockup del producto" className="w-full rounded-2xl shadow-2xl object-cover" data-id="element-103" />
          </Reveal>
        </div>
      </div>
    </section>;
}